<div class="dialog-header" [ngClass]="{ rounded: rounded(), transparent: transparent() }">
  <ng-content class="left-addon" select="[left-addon]" />
  <div class="title" [ngClass]="{ 'center-title': centerTitle() }">
    {{ title() }}
  </div>
  <ng-content class="right-addon" select="[right-addon]" />
</div>
